<template>
  <div class="wrapper">
    <div class="main">
      <div class="message" v-show="message !== null" :style="{ 'text-align': type === 'confirm' ? 'justify' : 'center' }">
        <span v-if="icon.show" :class="{ [icon.type]: true }"></span>
        {{message}}
      </div>
      <div class="btn-list" v-if="type === 'confirm'">
        <button
          v-for="(item, index) in btnList"
          :key="item.text + index"
          @click="clickHandle(item.value)"
          :class="{ [item.className]: true }"
        >
          {{ item.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopBox',
  data () {
    return {
      message: null,
      type: null,
      btnList: [],
      timer: null,
      icon: {
        show: false
      }
    }
  },
  watch: {
    type (newValue) {
      if (newValue === 'alert') {
        console.log('设置了定时器')
        this.timer = setTimeout(() => {
          this.type = null
          this.close()
        }, 500)
      } else {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  },
  methods: {
    clickHandle (val) {
      this.callback(val)
      this.close()
    },
    close () {
      document.querySelector('#app').removeChild(this.$el)
    }
  }
}
</script>

<style scoped="scoped">
.wrapper {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1000;
  color: black;
  position: absolute;
  background: rgba(0,0,0,0.35)
}
.main {
  max-width: 460px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  text-align: center;
  background: #ffffff;
}
.message {
  user-select: none;
  font-size: 24px;
  color: #333333;
  margin: 24px 50px;
  text-align: center;
  display: flex;
  align-items: center;
}
.message span {
  display: inline-block;
}
.message .true:after {
  content: '';
  display: block;
  width: 15px;
  height: 30px;
  border-bottom: 3px solid;
  border-right: 3px solid;
  position: relative;
  transform: rotate(45deg);
  right: 18px;
  top: -3px;
}
.btn-list {
  text-align: right;
  margin: 51px 50px 20px 50px;
  height:33px;
  line-height: 33px;
  display: flex;
  justify-content: space-between;
}
.btn-list button {
  width: 75px;
  height: 33px;
  display: inline-block;
  cursor: pointer;
  font-size: 18px;
  box-sizing: border-box;
}
.main .btn-list .btnConfirm {
  color: #cf4d57;
}
.btnReject {
}

.default .main {
  box-shadow: 0px 3px 6px rgba(0,0,0,0.15)
}
.default .btn-list button {
  color: #5b5b5b;
}
.default .main, .default .message {
  background: white;
  color: black;
}
.default .true:after {
  border-color: rgb(74, 181, 41);
}

.dark .main {
  box-shadow: 0px 3px 6px rgba(0,0,0,0.35)
}
.dark .btn-list button {
  color: #e6e6e6;
}
.dark .main, .dark .message {
  background: #434343;
  color: #ffffff;
}
.dark .true:after {
  border-color: rgb(74, 181, 41);
}
</style>



// WEBPACK FOOTER //
// src/mixin/pop/PopBox.vue